<template>
  <v-overlay :value="true" :opacity="0" z-index="9999">
    <v-progress-circular indeterminate size="64" color="primary" />
  </v-overlay>
</template>

<script>
export default {
  name: 'LoginFlowTransition',
};
</script>
